export const ROUTE_RESET_PASSWORD = 'reset-password';
